module.exports = __webpack_public_path__ + "img/law-serve-nav-icon08.722219f9.png";